import axios from "../utils/axios";

// Proxied through BOSS backend; PlantId is sent as a header so backend can pick the right P360 endpoint
export const postP360WorkOrderClosed = (payload, plantId) => {
    return axios.post(`/P360/WorkOrderClosed`, payload, {
        headers: { PlantId: plantId },
    });
};

export const getTaskDetailById = (id) => {
    return axios.get(`/UnplannedMaintenance/GetTaskDetailById?id=${id}`);
};

export const getSameLevelListById = (id) => {
    return axios.get(`/Equipment/GetSameLevelListById?equipmentId=${id}`);
};

export const getBreakdownRootCauseList = () => {
    return axios.get(`/BreakdownRootCause/GetDetailedList`);
};

export const getTechListByPoolId = (payload) => {
    return axios.get(`/User/GetTechnicianListByPoolId?poolId=${payload.poolId}`);
};

export const getBreakdownPoolList = () => {
    return axios.get(`/Pool/GetList`);
};

export const getBreakdownReasonList = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};

export const getBreakdownReasonListWithPoolRelations = (poolId) => {
    return axios.post(`/BreakdownReasonGroup/GetListWithPoolRelations?poolId=${poolId}`);
};

export const getUnplannedFiles = (id) => {
    return axios.get(`/UnplannedMaintenance/${id}/Files`, { responseType: "arraybuffer" });
};

export const getBreakdownEffectList = () => {
    return axios.get(`/BreakdownEffect/GetList`);
};

export const createSubTaskUnPlannedMaintenance = ({ id, poolId, taskInitialNote }) => {
    return axios.post(`/UnplannedMaintenance/CreateSubTask?taskId=${id}&poolId=${poolId}&taskInitialNote=${taskInitialNote}`);
};

export const playUnPlannedMaintenance = (id) => {
    return axios.post(`/UnplannedMaintenance/Play?taskId=${id}`);
};

export const startUnPlannedMaintenance = (id) => {
    return axios.post(`/UnplannedMaintenance/Start?taskId=${id}`);
};

export const closeUnPlannedMaintenance = (taskId) => {
    return axios.post(`/UnplannedMaintenance/Close?taskId=${taskId}`);
};

export const closeManyUnplannedTasks = (payload) => {
    return axios.post(`/UnplannedMaintenance/CloseMany`, payload);
}

export const pauseUnPlannedMaintenance = ({ taskId, pauseReasonId, pauseReasonNote }) => {
    return axios.post(`/UnplannedMaintenance/Pause?taskId=${taskId}&pauseReasonId=${pauseReasonId}&pauseReasonNote=${pauseReasonNote}`);
};

export const reopenUnplannedMaintenance = (taskId) => {
    return axios.post(`UnplannedMaintenance/ReOpen?taskId=${taskId}`);
};

export const completeUnPlannedMaintenance = (data) => {
    return axios.post(`/UnplannedMaintenance/Complete`, data);
};

export const addUnplannedMaintenaceOfTheReports = (data) => {
    return axios.post(`/UnplannedMaintenanceNonReportingTimes`, data);
};

export const getUnplannedMaintenaceOfTheReports = (taskId) => {
    return axios.get(`/UnplannedMaintenanceNonReportingTimes?taskId=${taskId}`);
};

export const deleteUnplannedMaintenaceOfTheReports = (taskId) => {
    return axios.delete(`/UnplannedMaintenanceNonReportingTimes/${taskId}`);
};

export const postUnplannedMaintenanceOfTheReports = (payload) => {
    return axios.post(`/UnplannedMaintenanceNonReportingTimes/paginated?PageSize=${payload.pageSize}&PageNumber=${payload.pageNumber}`, payload.body);
};

export const patchUnplannedMaintenanceOfTheReports = (payload) => {
    return axios.put(`/UnplannedMaintenanceNonReportingTimes/${payload.reportId}/${payload.statusAction}`);
};

export const updateUnPlannedMaintenance = (data) => {
    return axios.post(`/UnplannedMaintenance/Update`, data);
};

export const addTechnicianUnPlannedMaintenance = ({ taskId, userCode }) => {
    return axios.post(`/UnplannedMaintenance/AddTechnician?taskId=${taskId}&userCode=${userCode}`);
};

export const assignTaskUnPlannedMaintenance = ({ id, userCode }) => {
    return axios.post(`/UnplannedMaintenance/Assign?taskId=${id}&userCode=${userCode}`);
};

export const getListByStatusUnPlannedMaintenance = (payload) => {
    return axios.get(`/UnplannedMaintenance/GetList?statusArr=${payload.id || payload}`);
};

export const getBreakdownReasonPlaceListByGroupIdAndPoolRelations = ({id,poolId}) => {
    return axios.get(`/BreakdownReasonPlace/GetListByGroupIdAndPoolRelations?poolId=${poolId}&breakdownGroupId=${id}`);
};

export const getBreakdownReasonDetailListByPlaceId = (id) => {
    return axios.get(`/BreakdownReasonDetail/GetListByPlaceId?breakdownReasonPlaceId=${id}`);
};

export const addUnplannedFiles = (payload) => {
    return axios.post(`/UnplannedMaintenance/${payload.unplannedId}/Files`, payload.data);
};

export const getTaskHistoryByIdUnPlannedMaintenance = (id) => {
    return axios.get(`/UnplannedMaintenance/GetTaskHistoryById?id=${id}`);
};

export const getMaintenancePauseReasonList = () => {
    return axios.get(`/MaintenancePauseReason/GetList`);
};

export const deleteUnplannedFiles = (payload) => {
    return axios.delete(`/UnplannedMaintenance/${payload.unplannedId}/Files`, { data: payload.fileNames });
};

export const getEkedEquipmentList = (id) => {
    return axios.get(`/UnplannedMaintenance/GetEkedEquipmentList?id=${id}`);
};

export const updateEkedEquipmentList = (data) => {
    return axios.post(`/UnplannedMaintenance/UpdateEkedEquipment?taskId=${data.taskId}&ekedUsed=${data.ekedUsed}`, data.payload);
};

export const getCurrentUsersActiveTaskId = () => {
    return axios.post(`/UnplannedMaintenance/GetCurrentUsersActiveTaskId`);
};